export const getResultRating = (state, id) => state.resultRating.resultRatings.entries[id];
